<h2 mat-dialog-title>Seat Map</h2>
@if (seatMap$ | async; as seatMap) {
  <mat-dialog-content>
    @if (seatMap.isLoading && !seatMap.response) {
      <div class="loading-container">
        <mat-spinner color="accent" diameter="32" class="spinner"></mat-spinner>
      </div>
    }
    @if (seatMap.response) {
      @if (seatMap.response.rows.length === 0) {
        <div class="m-16 flex-center text-center">No seat map data</div>
      }
      @for (row of seatMap.response.rows; track $index; let rowIndex = $index) {
        <div class="seat-row">
          @if (row.sectionLabel) {
            <div class="section-label">{{ row.sectionLabel }}</div>
          }
          @if (row.note) {
            <div class="text-xs caution-color">{{ row.note }}</div>
          }
          @if (row.isBulkhead) {
            @for (seat of row.seats; track $index; let colIndex = $index) {
              @if (
                seat.seatType === SeatType.Bulkhead ||
                seat.seatType === SeatType.Blank
              ) {
                <div class="seat seat-letter bulkhead">
                  {{ seat.seatLetter }}
                </div>
              } @else {
                <div class="seat"></div>
              }
            }
          } @else {
            @for (seat of row.seats; track $index; let colIndex = $index) {
              @if (colIndex == 0) {
                @if (row.isExitRow) {
                  <div class="seat exit exit-left warn-color">Exit</div>
                } @else {
                  <div class="seat"></div>
                }
              }

              @switch (seat.seatType) {
                @case (SeatType.Blank) {
                  <div class="seat"></div>
                }
                @case (SeatType.Open) {
                  <div class="seat success-color">
                    <mat-icon fontSet="material-symbols-outlined"
                      >dialogs</mat-icon
                    >
                  </div>
                }
                @case (SeatType.Assigned) {
                  <div class="seat">
                    <mat-icon fontSet="material-symbols-outlined"
                      >disabled_by_default</mat-icon
                    >
                  </div>
                }
                @case (SeatType.Galley) {
                  <div class="seat service-item">
                    <mat-icon fontSet="material-symbols-outlined"
                      >coffee</mat-icon
                    >
                  </div>
                }
                @case (SeatType.Lav) {
                  <div class="seat service-item">
                    <mat-icon fontSet="material-symbols-outlined">wc</mat-icon>
                  </div>
                }
                @case (SeatType.Aisle) {
                  @if (row.rowNumber) {
                    <div class="seat opacity-6 flex-center">
                      {{ row.rowNumber }}
                    </div>
                  } @else {
                    <div class="seat"></div>
                  }
                }
              }

              @if (colIndex == row.seats.length - 1) {
                @if (row.isExitRow) {
                  <div class="seat exit exit-right warn-color">Exit</div>
                } @else {
                  <div class="seat"></div>
                }
              }
            }
          }
        </div>
      }
    }
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button
      [tabIndex]="-1"
      mat-raised-button
      mat-dialog-close
      color="primary"
      class="close-btn"
    >
      Close
    </button>
  </mat-dialog-actions>
  <div class="data-status">
    <app-data-status
      [timestamp]="seatMap.response?.timestamp"
      [isLoading]="seatMap.isLoading"
      (refresh)="refresh()"
    ></app-data-status>
  </div>
  <mat-progress-bar
    *ngIf="seatMap.isLoading"
    color="accent"
    mode="indeterminate"
  ></mat-progress-bar>
}
